
import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FloatingShapeComponent } from '@catch/general-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { ScreenService } from '@catch/services';
import { TranslocoService } from '@jsverse/transloco';
import confetti from 'canvas-confetti';
import { AnimationOptions } from 'ngx-lottie';
import { fadeInOut } from '../../../../assets/animations/animations';
import { JobboardAdapter } from '../../../adapters/jobboard.adapter';
import { CompanyInfo } from '../../../interfaces/company-info';
import { ColorService } from '../../../services/color.service';
import { FontawesomeService } from '../../../services/fontawesome.service';
import { SEOService } from '../../../services/seo.service';

@Component({
  selector: 'app-talentpool-accept',
  templateUrl: './talentpool-accept.component.html',
  styleUrls: ['./talentpool-accept.component.scss'],
  animations: [fadeInOut],
  imports: [FloatingShapeComponent, TranslocoPipe],
})
export class TalentpoolAcceptComponent implements OnInit {
  @ViewChild('confettiTrigger') confettiTrigger: ElementRef;
  inProgress: boolean = false;
  success: boolean = false;
  accepted: boolean = false;
  expired: boolean = false;
  expiredLottie: AnimationOptions = {
    path: '../../../../assets/animations/expired.json',
  };
  company: CompanyInfo;

  private readonly colorService = inject(ColorService);
  private readonly jobboardAdapter = inject(JobboardAdapter);
  private readonly route = inject(ActivatedRoute);
  private readonly seoService = inject(SEOService);
  private readonly translateService = inject(TranslocoService);
  public readonly fontawesomeService = inject(FontawesomeService);
  public readonly screenService = inject(ScreenService);

  ngOnInit(): void {
    this.colorService.setDesign(this.route.snapshot.params['companyId']);
    this.jobboardAdapter
      .getCompanyInfo(this.route.snapshot.params['companyId'])
      .subscribe({
        next: (result: CompanyInfo) => {
          this.seoService.updateTitle(
            this.translateService.translate(
              'jobboard.views.talentpool-invitation.tab-title',
              { companyName: result.title }
            )
          );
          this.seoService.updateDescription('');
          this.company = result;
        },
      });
  }

  accept() {
    this.inProgress = true;
    this.jobboardAdapter
      .acceptTalentpoolInvitation(
        this.route.snapshot.params['applicationId'],
        this.route.snapshot.queryParams['nonce']
      )
      .subscribe({
        next: () => {
          this.success = true;
          this.accepted = true;
          this.inProgress = false;
          confetti({
            particleCount: 50,
            spread: 70,
            origin: { y: 0.6 },
          });
        },
        error: () => {
          this.inProgress = false;
          this.expired = true;
        },
      });
  }

  decline() {
    this.inProgress = true;
    this.jobboardAdapter
      .declineTalentpoolInvitation(
        this.route.snapshot.params['applicationId'],
        this.route.snapshot.queryParams['nonce']
      )
      .subscribe({
        next: () => {
          this.success = true;
          this.accepted = false;
          this.inProgress = false;
        },
        error: () => {
          this.inProgress = false;
          this.expired = true;
        },
      });
  }

  get correctedBackgroundColor(): string {
    if (this.colorService.background) {
      if (
        this.colorService.background.startsWith('rgb') &&
        !this.colorService.background.startsWith('rgba')
      ) {
        return (
          this.colorService.background.substring(
            0,
            this.colorService.background.length - 2
          ) + ', 0.133333)'
        );
      } else if (
        this.colorService.background.startsWith('#') &&
        this.colorService.background.length <= 7
      ) {
        return this.colorService.background + '22';
      } else {
        return this.colorService.background;
      }
    }
    return '';
  }
}
